import * as React from 'react'

const DisplayStudentHighlight = ({ studentHighlight, removeHighlight, inReflection, }) => {
  function handleClickRemove() { removeHighlight(studentHighlight)}

  return (
    <div className="display-student-highlight">
      <span id={studentHighlight}>{studentHighlight}</span>
      {inReflection ? <span /> : <button aria-describedby={studentHighlight} aria-label="Remove highlight" className="quill-button outlined red extra-small focus-on-light" onClick={handleClickRemove} type="button">Remove</button>}
    </div>
  )
}

export default DisplayStudentHighlight
